import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
import logo from '../../../assets/logo-sebrae.png';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const ContainerHeader = styled.div`
  ${({ isAuthenticated }) =>
    isAuthenticated
      ? css`
          position: relative;
          z-index: ${BaSeTheme.stackOrder.normal + 1};
          width: 100%;
          display: flex;
          justify-content: center;
          background-color: ${BaSeTheme.colors.defaultColors.black};

          &::before {
            position: absolute;
            content: '';
            width: 100vw;
            height: 60px;
            display: block;
            top: 0;
            right: 0;
            background: radial-gradient(
              circle at top right,
              ${({ gradientColor }) => gradientColor} -10vw,
              transparent 40vw
            );
          }
        `
      : css`
          position: relative;
          z-index: ${BaSeTheme.stackOrder.normal + 1};
          width: 100%;
          display: flex;
          justify-content: center;
        `}
`;

export const HeaderWrapper = styled.div`
  min-height: 60px;
  width: 100%;
  div {
    box-shadow: none;
  }
  .BaSe--account-profile-name-abbr-icon {
    color: ${BaSeTheme.colors.institucionais.cinzaSebrae10};
  }
`;

export const LogoSebrae = styled.div`
  width: 68px;
  height: 36.26px;
  background: url(${logo});
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${handleQuery(`
    width: 500px;
  `)}
`;

export const HeaderTitle = styled.p`
  font-family: 'Lato';
  font-size: 23px;
  font-weight: 700;
  line-height: 27.6px;
  display: flex;
  align-items: center;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae75};
  padding-left: 17px;
  white-space: nowrap;

  ${handleQuery(`
    font-size: 16px;
  `)}
`;

export const LineHeader = styled.hr`
  margin: 0;
  border: none;
  height: 1px;
  background: rgba(240, 246, 254, 0.5);
`;

export const CustomComponentsWrapper = styled.div`
  background-color: ${BaSeTheme.colors.defaultColors.transparent};
  width: 100%;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CustomButtonsComponentsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BoxLocalization = styled.div`
  background-color: ${BaSeTheme.colors.defaultColors.transparent};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae60};
  border-radius: 5px;
  height: 18px;
  padding: 2px 5px 2px 5px;
`;

export const HeaderItems = styled.div`
  display: flex;
`;

export const HeaderItem = styled.button`
  cursor: pointer;
  border: none;
  background-color: ${BaSeTheme.colors.defaultColors.transparent};
  height: 40px;
  width: 25px;

  &:hover {
    background-color: rgba(139, 153, 167, 0.2);
  }
`;
